var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('div',{staticClass:"ml-4 pt-4 pb-2"},[_vm._t("default")],2)]),(_vm.hasAction)?_c('v-flex',{attrs:{"shrink":"","pr-4":"","pt-2":"","pb-0":""}},[_vm._t("action")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }